import i18n from 'i18n/config';

const getT = (t) => (typeof t === 'function' ? t : i18n.t.bind(i18n));

export const getRoleOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('roles.admin', { defaultValue: 'Admin' }), value: 'admin' },
    { text: tr('roles.orgAdmin', { defaultValue: 'Org Admin' }), value: 'org_admin' },
    { text: tr('roles.analyst', { defaultValue: 'Analyst' }), value: 'analyst' },
    { text: tr('roles.manager', { defaultValue: 'Manager' }), value: 'manager' },
    { text: tr('roles.technician', { defaultValue: 'Technician' }), value: 'technician' },
  ];
};

// Deprecated: prefer getRoleOptions(t).
export const roleOptions = getRoleOptions();

export const getPetasenseAdminRoleAllowedOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('roles.petasenseAdmin', { defaultValue: 'Petasense Admin' }), value: 'petasense_admin' },
    { text: tr('roles.partnerAdmin', { defaultValue: 'Partner Admin' }), value: 'partner_admin' }
  ];
};

export const petasenseAdminRoleAllowedOptions = getPetasenseAdminRoleAllowedOptions();

export const getPartnerAdminRoleAllowedOptions = (t) => {
  const tr = getT(t);
  return [
    { text: tr('roles.partnerAdmin', { defaultValue: 'Partner Admin' }), value: 'partner_admin' }
  ];
};

export const partnerAdminRoleAllowedOptions = getPartnerAdminRoleAllowedOptions();
